import React from "react";

const BillPrintHeader = () => {
  return (
    <>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>
                     
                      <div style={{ textAlign: "left" }}>
                        <span
                          style={{
                            fontFamily: "Cinzel Decorative",
                            fontSize: "1.2rem",
                            color: "rgb(0, 0, 0)",
                          }}
                        >
                          Dr. S. Farzana Ferdousy
                        </span>
                      </div>
                      <div
                        style={{
                          marginTop: "1rem",
                          fontSize: "0.9rem",
                          textAlign: "left",
                          fontWeight: 500,
                        }}
                      >
                        <div className="designation">
                          BDS, FCPS (Orthodontics)
                        </div>
                        <div className="designation">Fellow WFO(USA)</div>
                        <div className="designation">
                          Assistant Professor &amp; Head, (Ex)
                        </div>
                        <div className="designation">
                          Department of Orthodontics
                        </div>
                        <div className="designation">Delta Medical College</div>
                        <div className="designation">
                          <span style={{ color: "rgb(0, 0, 0)" }}>
                            BMDC Reg No: 3008
                          </span>
                        </div>
                      </div>
                      {/* <br /> */}
                    </td>
                    <td style={{ width: "20%" }}>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <div className="mid">SERVICE RECEIPT 2</div>
                      <div style={{ textAlign: "right" }}>
                        <br />
                      </div>
                    </td>
                    <td style={{ width: "40%" }}>
                      <div data-empty="true" style={{ textAlign: "center" }}>
                      
                      
                          <img
                            alt="logo"
                            src="http://localhost:3000/tempimage/ir-dental-station-logo.png"
                            style={{ height: "150px" }}
                            // style={{ width: "300px" }}
                            className="fr-fic fr-dib fr-fir"
                          />
                      
                      <p>

                     
                        <span
                          className="designation"
                          style={{ color: "rgb(0, 0, 0)" }}
                        >
                          Consultation
                        </span>
                        <span style={{ color: "rgb(0, 0, 0)" }}>
                          <br />
                          <span className="designation">
                            Mon-Sat: 10:00am-09:00pm
                          </span>
                          <br />
                        </span>

                        <span
                          className="designation"
                          style={{ color: "rgb(0, 0, 0)" }}
                        >
                          Sunday Close
                        </span>
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "30%" }}>
                      <br />
                    </td>
                    <td style={{ width: "40%" }}>
                      <br />
                    </td>
                    <td>
                      <br />
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr />
            </th>
          </tr>
          <tr>
            <th></th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <td id="spacer"></td>
          </tr>
        </tfoot>
        <tbody></tbody>
      </table>
    </>
  );
};

export default BillPrintHeader;
